import { render, staticRenderFns } from "./intoBankCardList.vue?vue&type=template&id=2a65fb12&scoped=true&"
import script from "./intoBankCardList.vue?vue&type=script&lang=js&"
export * from "./intoBankCardList.vue?vue&type=script&lang=js&"
import style0 from "./intoBankCardList.vue?vue&type=style&index=0&id=2a65fb12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65fb12",
  null
  
)

export default component.exports